export * from './post-foto-kategorie-request.interface';
export * from './post-foto-kategorie-response.interface';
export * from './post-foto-kategorie.shapes';
